module.exports = "/_next/static/media/9022a0cbc82acddc3f11dde2c9e27fb4.png";